import React from 'react';
import { Box, MUIDataTableColumnDef, TableState, Typography } from 'web-library';
import { SubjectPaper } from '../../../../modules/accessArrangment/components/candidate/AccessArrangementRequest/AccessArrangementRequestModels';

export const useAccessArrangementReviewColumns = (
  state: TableState,
  classes: any
): MUIDataTableColumnDef[] => [
  {
    name: 'requestType',
    label: 'Request Type',
    options: {
      customBodyRenderLite: (dataIndex: number) => {
        if (dataIndex === undefined) {
          return [];
        }

        return state.data[dataIndex].accessArrangementType.description;
      },
    },
  },
  {
    name: 'remarks',
    label: 'Remarks',
    options: {
      sort: false,
      setCellProps: () => ({
        style: {
          maxWidth: '400px',
        },
      }),
      customBodyRenderLite: (dataIndex: number) => {
        if (!state.data[dataIndex].remarks) {
          return '-';
        }

        return state.data[dataIndex].remarks;
      },
    },
  },
  {
    name: 'modeOfAssessment',
    label: 'Mode of Assessment',
    options: {
      customBodyRenderLite: (dataIndex: number) => {
        if (dataIndex === undefined) {
          return [];
        }

        return state.data[dataIndex].modeOfAssessment.description;
      },
    },
  },
  {
    name: 'examSeries',
    label: 'Exam Series',
    options: {
      sort: false,
      customBodyRenderLite: (dataIndex: number) => {
        if (dataIndex === undefined) {
          return [];
        }

        const columnData: any[] = Object.keys(state.data[dataIndex].subjectPapers);

        const cell: any[] = [];
        const heights: number[] = [];

        const examLevelSubjectPapers: any[] = Object.values(state.data[dataIndex].subjectPapers);

        examLevelSubjectPapers.forEach((examLevelSubjectPaper) => {
          const examLevels: string[] = Object.keys(examLevelSubjectPaper);
          const subjectPapers: any[] = Object.values(examLevelSubjectPaper);
          let height = 0;

          examLevels.forEach((examLevel, index) => {
            height += 40;

            subjectPapers[index].forEach(() => {
              height += 24;
            });
          });

          heights.push(height);
        });

        columnData.forEach((examSeries, index) => {
          cell.push(
            <Box key={examSeries} style={{ minHeight: heights[index] }}>
              {examSeries}
            </Box>
          );
        });

        return cell;
      },
    },
  },
  {
    name: 'subjectPaper',
    label: 'Subject(s)/Paper(s)',
    options: {
      sort: false,
      customBodyRenderLite: (dataIndex: number) => {
        if (dataIndex === undefined) {
          return [];
        }

        const cell: any[] = [];

        const columnData: any[] = Object.values(state.data[dataIndex].subjectPapers);

        columnData.forEach((examLevelSubjectPaper) => {
          const examLevels: string[] = Object.keys(examLevelSubjectPaper);
          const subjectPapers: any[] = Object.values(examLevelSubjectPaper);

          cell.push(
            examLevels.map((examLevel, index) => (
              <Box key={examLevel} className={classes.spaceBottom}>
                <Typography variant="h6" className={classes.examLevel}>
                  {examLevel}
                </Typography>
                {subjectPapers[index].map((subjectPaper: SubjectPaper) => (
                  <Box
                    key={`${examLevel}-${subjectPaper.subject}`}
                    display="flex"
                    whiteSpace="nowrap"
                  >
                    {subjectPaper.subject}
                    {subjectPaper.dropped && (
                      <Typography variant="body2" className={classes.dropped}>
                        (Dropped)
                      </Typography>
                    )}
                  </Box>
                ))}
              </Box>
            ))
          );
        });

        return cell;
      },
    },
  },
];
